import TicketsListing from '../../components/TicketsListing'
import TopSideBar from '../../components/TopSideBar'
import Copyright from '../../components/common/Copyright'

export default function TicketsListingPage({ setBlockScreen }: any) {

  return <>
    <TopSideBar currentSection='tickets' />
    <TicketsListing
      setBlockScreen={setBlockScreen}
    />
    <Copyright />
  </>
}